export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail alebo používateľské meno',
      invalidEmailOrUsername: 'Nesprávny e-mail alebo používateľské meno',
      invalidPassword: 'Nesprávne heslo',
      noInternetConnection: 'Bez pripojenia k internetu',
      pageNotFound_title: 'Stránka neexistuje',
      password: 'Heslo',
      projectManagement: 'Správa projektu',
      serverConnectionFailed: 'Pripojenie k serveru zlyhalo',
      unknownError: 'Neznáma chyba, skúste to neskôr',
    },

    action: {
      logIn: 'Prihlásiť sa',
    },
  },
};
